module.exports = __webpack_public_path__ + "media/images/wastebasket-light-fbdcc8777138bf6b3e4aca29fdff0721.svg";